export const TESTNET_CHAIN_ID = '97'
export const MAINNET_CHAIN_ID = '56'
export const MAINNET_ETH_CHAIN_ID = '1'
export const RINKEBY_CHAIN_ID = '4'
export const BASE_BSC_SCAN_URL = 'https://bscscan.com'
